import { VirtualClinicAnalysisOperatingNumberTerm } from '../term';
import { isCalculationTermComplete } from '@bindoc-projects/util-domain-lib';
import type { OverrideProperty } from '@bindoc-projects/util-domain-lib';
import type { ShareableType } from '@bindoc-projects/resource-domain-lib';
import { VirtualClinicAnalysisVirtualClinicOperatingNumberFilter } from './filter';
import type { VirtualClinicAnalysisFullyInpatientCasesFilter } from '../../filter/fully-inpatient-cases';

export class VirtualClinicAnalysisVirtualClinicOperatingNumber extends VirtualClinicAnalysisOperatingNumberTerm {
  public static async fromObject(
    obj: { operatingNumberId?: string; virtualClinicFilter?: unknown } = {},
  ): Promise<VirtualClinicAnalysisVirtualClinicOperatingNumber> {
    const virtualClinicFilter =
      VirtualClinicAnalysisVirtualClinicOperatingNumberFilter.fromObject(
        obj.virtualClinicFilter,
      );

    return new VirtualClinicAnalysisVirtualClinicOperatingNumber(
      obj.operatingNumberId,
      virtualClinicFilter,
    );
  }

  constructor(
    public operatingNumberId: string,
    public virtualClinicFilter: VirtualClinicAnalysisVirtualClinicOperatingNumberFilter,
  ) {
    super('virtualClinicOperatingNumber');
  }

  clone(): VirtualClinicAnalysisOperatingNumberTerm {
    const filterClone = this.virtualClinicFilter
      ? this.virtualClinicFilter.clone()
      : null;

    return new VirtualClinicAnalysisVirtualClinicOperatingNumber(
      this.operatingNumberId,
      filterClone,
    );
  }

  overrideClone(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Required by abstract base class
    _override: OverrideProperty[],
  ): VirtualClinicAnalysisOperatingNumberTerm {
    const filterClone = this.virtualClinicFilter
      ? this.virtualClinicFilter.clone()
      : null;

    return new VirtualClinicAnalysisVirtualClinicOperatingNumber(
      this.operatingNumberId,
      filterClone,
    );
  }

  getChildResources(): { [resourceName in ShareableType]?: string[] } {
    return {};
  }

  getFullyInpatientCasesFilters(): VirtualClinicAnalysisFullyInpatientCasesFilter[] {
    return [];
  }

  getOverrideProperties(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Required by abstract base class
    _tileId: string,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Required by abstract base class
    _dependencyVirtualClinicId: string,
  ): OverrideProperty[] {
    return [];
  }

  isValid(): boolean {
    return isCalculationTermComplete<VirtualClinicAnalysisOperatingNumberTerm>(this);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Return type must match base class abstract method
  toJSON(): any {
    return {
      type: this.type,
      operatingNumberId: this.operatingNumberId,
      condition: this.virtualClinicFilter.toCondition(),
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Required by abstract base class
  onUpdateVirtualClinicId(_virtualClinicId: string): void {
    // nothing to do
  }
}
